import { AiFillHome, AiFillFolder } from 'react-icons/ai';
import { BsPersonFill, BsCreditCard2FrontFill } from 'react-icons/bs';
import { IoIosSwitch } from 'react-icons/io';
import { FaPen, FaFastForward } from 'react-icons/fa';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { RiStethoscopeLine } from 'react-icons/ri';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import React, { useMemo } from 'react';
import DoctorResultsPage from 'pages/DoctorResultsPage';
import PatientDetailsPage from 'pages/customer-kits-overview/pages/PatientDetailsPage';
import CorporateWelcomePage from 'pages/CorporateWelcomePage';
import CorporateRegisterAndViewResultsPage from 'pages/CorporateRegisterAndViewResultsPages';
import CorporateProfilePage from 'pages/CorporateProfilePage';
import InviteADoctor from 'pages/InviteADoctor';
import { useAuth } from 'AuthCtx';
import useAPI from 'hooks/api-hooks';
import DoctorConsentsToCorporate from 'pages/customer-kits-overview/pages/DoctorConsentsToCorporate';
import ExplanationOfResultsWrapper from 'pages/ExplanationOfResultsWrapper';
import CardBase from '../../app/CardBase';
import DoctorKitRegistrationDashboard, { DoctorKitRegistrationDashboardResume } from '../DoctorKitRegistrationDashboard';
import CorporateKitRegistrationDashboardAll from '../CorporateKitRegistrationDashboardAll';

const CardBaseWrapper = ({ children }) => {
  return (
    <CardBase withShadow align='left'>
      {children}
    </CardBase>
  );
};

const boxAroundIconCorporate = {
  // height: '10vh',
  // width: '10vh',
  padding: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgb(227, 137, 148)',
  border: '1px solid #E38994',
  boxShadow: '0px 0px 9px rgb(221, 162, 169)',
  borderRadius: '10px',
};

/*
const DoctorGeneral = () => {
  const { userAttributes } = useAuth();
  const { t } = useTranslation();

  if (!userAttributes) {
    return null;
  }
  const verified = 'VERIFIED' === userAttributes.verificationStatus;

  if (!verified) {
    return (
      <Grid item xs={ 12 }>
        <Alert severity='info'>
          <AlertTitle>
            { t('Pending verification') }
          </AlertTitle>
          { t('Your registration is not yet completed. You will be notified with an email once completed.') }
        </Alert>
      </Grid>
    );
  }
  return (
    <NoDataPage title={ t('general') } />
  );
}; */

export const profileIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <AccountCircleIcon style={ { height: '50px', width: '50px', color: 'white' } } />
    </div>
  );
};

const registeredKitsIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <BsCreditCard2FrontFill style={ { height: '50px', width: '50px', color: 'white' } } />
    </div>
  );
};

const repeatIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <IoIosSwitch style={ { height: '50px', width: '50px', color: 'white' } } />
    </div>
  );
};

const resumeRegistrationKitsIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <FaFastForward style={ { height: '50px', width: '50px', color: 'white' } } />
    </div>
  );
};

const resultsDoctorIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <IoDocumentTextOutline style={ { height: '50px', width: '50px', color: 'white' } } />
    </div>
  );
};

const doctorsIconBig = () => {
  return (
    <div style={ boxAroundIconCorporate }>
      <img
        src='/doctors-50x50px.svg'
        alt=''
        style={ {
          filter: 'invert(100%) sepia(0%) saturate(5009%) hue-rotate(137deg) brightness(1000%) contrast(109%)',
        } }
      />
    </div>
  );
};

const homeIcon = ({ isActive }) => {
  return (
    <AiFillHome color={ isActive ? 'white' : '#666666' } />
  );
};

const registerAndResultsIcon = ({ isActive }) => {
  return (
    <AiFillFolder color={ isActive ? 'white' : '#666666' } />
  );
};

const newKitRegisterIcon = ({ isActive }) => {
  return (
    <FaPen color={ isActive ? 'white' : '#666666' } />
  );
};

const kitIcon = ({ isActive }) => {
  return (
    <BsCreditCard2FrontFill color={ isActive ? 'white' : '#666666' } />
  );
};

const resumeKitIcon = ({ isActive }) => {
  return (
    <FaFastForward color={ isActive ? 'white' : '#666666' } />
  );
};

const resultsIcon = ({ isActive }) => {
  return (
    <IoDocumentTextOutline color={ isActive ? 'white' : '#666666' } />
  );
};

const invitationsIcon = ({ isActive }) => {
  return (
    <RiStethoscopeLine color={ isActive ? 'white' : '#666666' } />
  );
};

const profileIcon = ({ isActive }) => {
  return (
    <BsPersonFill color={ isActive ? 'white' : '#666666' } />
  );
};

const useCorporateNavigationPages = () => {
  const { client } = useAPI();
  const { isCorporateAdmin } = useAuth(client);

  const navigationPages = useMemo(() => {
    return [
      {
        id: 'general',
        title: 'home',
        Component: CorporateWelcomePage,
        wrapperComponent: null,
        Icon: homeIcon,
        BigIcon: registeredKitsIconBig,
        type: 'item',
        isMenuHidden: false,
      },
      {
        id: 'explanationOfResults',
        title: 'explanationOfResults',
        Component: ExplanationOfResultsWrapper,
        wrapperComponent: null,
        type: 'item',
        isMenuHidden: true,
      },
      {
        id: 'patientDetails',
        title: 'patientDetails',
        Component: PatientDetailsPage,
        wrapperComponent: null,
        Icon: AiFillHome,
        type: 'item',
        isMenuHidden: true,
      },
      {
        id: 'patientQuestionnaire',
        title: 'patientQuestionnaire',
        Component: PatientDetailsPage,
        wrapperComponent: null,
        Icon: AiFillHome,
        type: 'item',
        isMenuHidden: true,
      },

      ...isCorporateAdmin ? [
        {
          id: 'resultsDoctor',
          title: 'results',
          Component: DoctorResultsPage,
          wrapperComponent: CardBaseWrapper,
          Icon: resultsIcon,
          type: 'item',
          BigIcon: resultsDoctorIconBig,
          isMenuHidden: false,
        },
      ] : [],

      {
        id: 'register-and-view-folder',
        title: 'Εγγραφή & αποτελέσματα ασθενών',
        Component: CorporateRegisterAndViewResultsPage,
        BigIcon: registeredKitsIconBig,
        wrapperComponent: CardBaseWrapper,
        Icon: registerAndResultsIcon,
        type: 'folder',
        isMenuHidden: isCorporateAdmin,
        items: [
          {
            id: 'registerNewKitDoctor',
            title: 'newKitRegistration',
            Component: CorporateKitRegistrationDashboardAll,
            wrapperComponent: CardBaseWrapper,
            Icon: newKitRegisterIcon,
            type: 'folder',
            BigIcon: registeredKitsIconBig,
            isMenuHidden: false,
            items: [
              {
                id: 'registerNewKitDoctorPGx',
                title: 'iDNA PGx CNS',
                Component: DoctorKitRegistrationDashboard,
                wrapperComponent: CardBaseWrapper,
                Icon: kitIcon,
                type: 'item',
                BigIcon: registeredKitsIconBig,
                isMenuHidden: false,
              },
              {
                id: 'registerNewKitDoctorCardio',
                title: 'iDNA Cardio Health',
                Component: DoctorKitRegistrationDashboard,
                wrapperComponent: CardBaseWrapper,
                Icon: kitIcon,
                type: 'item',
                BigIcon: registeredKitsIconBig,
                isMenuHidden: false,
              },
              {
                id: 'registerNewKitDoctorNutrigenetixLabs',
                title: 'iDNA NutriGenetix',
                Component: DoctorKitRegistrationDashboard,
                wrapperComponent: CardBaseWrapper,
                Icon: kitIcon,
                type: 'item',
                BigIcon: repeatIconBig,
                isMenuHidden: false,
              },
            ],
          },
          {
            id: 'resumeRegisterKitDoctor',
            title: 'resumeKitRegistration',
            Component: DoctorKitRegistrationDashboardResume,
            wrapperComponent: CardBaseWrapper,
            Icon: resumeKitIcon,
            type: 'folder',
            hideExpandIcons: true,
            items: [],
            BigIcon: resumeRegistrationKitsIconBig,
            isMenuHidden: isCorporateAdmin,
          },
          {
            id: 'resultsDoctor',
            title: 'results',
            Component: DoctorResultsPage,
            wrapperComponent: CardBaseWrapper,
            Icon: resultsIcon,
            type: 'folder',
            hideExpandIcons: true,
            items: [],
            BigIcon: resultsDoctorIconBig,
            isMenuHidden: false,
          },
        ],
      },
      {
        id: 'doctorsHealthProfessionals',
        title: 'invitations',
        Component: DoctorConsentsToCorporate,
        wrapperComponent: CardBaseWrapper,
        Icon: invitationsIcon,
        BigIcon: doctorsIconBig,
        alternativeIds: [ 'invite-a-doctor' ],
        type: 'item',
        isMenuHidden: isCorporateAdmin,
      },
      {
        id: 'invite-a-doctor',
        title: 'inviteADoctor',
        Component: InviteADoctor,
        wrapperComponent: CardBaseWrapper,
        type: 'item',
        isMenuHidden: true,
      },
      {
        id: 'profile',
        title: 'profile',
        Component: CorporateProfilePage,
        wrapperComponent: CardBaseWrapper,
        BigIcon: profileIconBig,
        Icon: profileIcon,
        type: 'item',
        isMenuHidden: false,
      },
    ];
  }, [ isCorporateAdmin ]);

  return navigationPages;
};

export default useCorporateNavigationPages;

